/**
 *  EDAP events
 */

const actionlocation = 'linkpiles-module';

export const LINKPILES_CLICK_PREV = {
  name: 'nav.previous.click',
  data: {
    actionlocation
  }
};

export const LINKPILES_CLICK_NEXT = {
  name: 'nav.next.click',
  data: {
    actionlocation
  }
};

export const LINKPILES_REGION_LINK_CLICK = {
  name: 'region.link.click',
  data: { // TODO LN: substitute the actionlocation with the eventlbsuuid after hp-api linkpiles service implementation
    actionlocation
  }
};

export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation
};


// WEBPACK FOOTER //
// ./src/universal/components/LinkPiles/events.js